/* eslint-disable */
export class Conf {
  static idempiereUrl = "https://idempiere.vecositalia.it/";

  static windowTitle = "Smart Calendar";

  static buildNo = "2023-01-13_165711"

}
